import utf8 from 'utf8'
export function clean(desc) {
    var buffer = [];
    if (!desc) {
      return "";
    }
    for (var i = 0; i < desc.length; i++) {
      if (desc.charCodeAt(i) > 255) {
        console.log(i + " > " + desc[i] + " > " + desc.charCodeAt(i));
      }
      if (
        !(
          desc.charCodeAt(i) == 226 ||
          desc.charCodeAt(i) == 8364 ||
          desc.charCodeAt(i) == 8462 ||
          desc.charCodeAt(i) == 732 ||
          desc.charCodeAt(i) == 157 ||
          desc.charCodeAt(i) == 339
        )
      ) {
        buffer.push(desc[i])
      }
    }
    var result = "not valid utf-8 string"
    try {
      result = utf8.decode(buffer.join(''))
    } catch(e) {
    }
    return result
}